
namespace khi.bk117.view.parts
{
	import Debugger = com.enirva.debug.Debugger;
	import EventDispatcher = com.enirva.event.EventDispatcher;

	/*
	 * Youtube再生時の制御
	 */
	export class YoutubeContainer extends EventDispatcher
	{
		//private width:number;

		//private height:number;

		public static canScroll:boolean;

		constructor(/*width:number = 960, height:number = 540*/)
		{
			super();

			YoutubeContainer.canScroll = true;

			/*
			this.width = width;
			this.height = height;

			$(".youtube").css({
				"width" : width,
				"height" : height,
				"margin-top" : "calc(100vh/2 - " + (height/2) + "px)"
			});
			*/


			/*
			 * open時にイベントセット、close時イベントRemoveとしていたが
			 * IE11だと、なぜかイベントがremoveされなかったので、初回にイベントセットしたままにしておき
			 * フラグにより、preventDefaultの実行有無を管理するように変更。
			 */
			var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

			window.addEventListener(scroll_event, this.dontScroll, {passive:false});
			window.addEventListener("scroll", this.dontScroll, {passive:false});
			window.addEventListener("touchmove", this.dontScroll, {passive:false});
			window.addEventListener("keydown", this.dontScroll, {passive:false});
		}


		public open(url:string, width:number, height:number):void
		{
			//https://www.youtube.com/embed/kPOimMmGcnA?rel=0&amp;showinfo=0&amp;version=3&amp;enablejsapi=1
			
			$(".youtube").css({
				"width" : width,
				"height" : height,
				"margin-top" : "calc(100vh/2 - " + (height/2) + "px)"
			});

			const movie:JQuery = $('<iframe width="' + width + '" height="' + height + '" src="https://www.youtube.com/embed/' + url + '?rel=0&amp;showinfo=0&amp;version=3&amp;enablejsapi=1" frameborder="0" allowfullscreen></iframe>');

			$(".youtubeContainer").fadeIn(300, ()=>
			{
				$(".youtubeContainer .iframeContainer").append(movie);
			});

			YoutubeContainer.canScroll = false;

			/*
			var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
				 
			window.addEventListener(scroll_event, this.dontScroll, {passive:false});
			window.addEventListener("scroll", this.dontScroll, {passive:false});
			window.addEventListener("touchmove", this.dontScroll, {passive:false});
			window.addEventListener("keydown", this.dontScroll, {passive:false});
			*/
		}


		private dontScroll(e:MouseEvent):void
		{
			if (!YoutubeContainer.canScroll)
			{
				//console.log("dontScroll");
				e.preventDefault();
			}
		}


		public close():void
		{
			$(".youtubeContainer").fadeOut(300, ()=>
			{
				$(".youtubeContainer .iframeContainer").empty();
			});

			YoutubeContainer.canScroll = true;
			
			/*
			var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

			window.removeEventListener(scroll_event, this.dontScroll);
			window.removeEventListener("scroll", this.dontScroll);
			window.removeEventListener("touchmove", this.dontScroll);
			window.removeEventListener("keydown", this.dontScroll);
			*/
		}
	}
}

